<ion-content class="ion-no-padding">
  <form class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue">Quote Review ({{quoteId}}) - {{leadDetails?.firstName}} {{leadDetails?.lastName}}</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button [ngStyle]="{ 'display': showConvertButton ? 'block' : 'none' }" class="filled-blue-btn" (click)="convertQuote()" *ngIf="quoteStatus === RECORD_STATUS_VALUES.CONFIRMED">
            Convert
          </ion-button>
          <ion-button [ngStyle]="{ 'display': showFinalizeButton ? 'block' : 'none' }" class="filled-blue-btn" (click)="finalizeQuote()" *ngIf="quoteStatus === RECORD_STATUS_VALUES.ACTIVE">
            Confirm
          </ion-button>
          <!-- <ion-button [ngStyle]="{ 'display': showFinalizeButton ? 'block' : 'none' }" class="filled-blue-btn" (click)="finalizeAndConvertQuote()" *ngIf="quoteStatus === RECORD_STATUS_VALUES.ACTIVE">
            Confirm and Convert
          </ion-button> -->
          <ion-button [ngStyle]="{ 'display': editQuoteButton ? 'block' : 'none' }" class="filled-blue-btn" (click)="openEditQuoteItinerary()" *ngIf="quoteStatus !== RECORD_STATUS_VALUES.INACTIVE && quoteStatus !== RECORD_STATUS_VALUES.CONVERTED && quoteStatus !== RECORD_STATUS_VALUES.TRIP_COMPLETED"> 
            Edit
          </ion-button>
          <ion-button [ngStyle]="{ 'display': editQuoteButton ? 'block' : 'none' }" class="filled-blue-btn" (click)="submitQuote()" *ngIf="quoteStatus === RECORD_STATUS_VALUES.DRAFT">
            Submit
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="openDownloadPopover($event)">
            Download
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="sendQuote($event)" [disabled]="!enableSendQuoteButton()" *ngIf="quoteStatus">
            Send
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="model-content" >
      <div  id="print-quote-section" class="quote-data-html d-flex justify-content-center" [innerHTML]="quoteDataHtml">
        <!-- Putting rendered html data here -->
      </div>
    </div>

  </form>
</ion-content>



<!-- ---------------------- -->
  